import ArticleIcon from '@mui/icons-material/Article';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

export type CaptableViewMode = 'summary' | 'detailed' | 'security';

interface IViewModeToggleProps {
  value: CaptableViewMode;
  onChange: (value: CaptableViewMode) => void;
}

export function ViewModeToggle({ value, onChange }: IViewModeToggleProps) {
  return (
    <ToggleButtonGroup
      color='secondary'
      value={value}
      exclusive
      onChange={(_, newValue) => {
        if (newValue !== null) {
          onChange(newValue);
        }
      }}
      aria-label='View mode'
    >
      <ToggleButton value='summary' title='Show captable summary'>
        <DonutLargeIcon fontSize='small' sx={{ marginRight: '0.25rem' }} />
        Summary
      </ToggleButton>
      <ToggleButton value='detailed' title='Show detailed view'>
        <TroubleshootIcon fontSize='small' sx={{ marginRight: '0.25rem' }} />
        Details
      </ToggleButton>
      <ToggleButton value='security' title='Show security view'>
        <ArticleIcon fontSize='small' sx={{ marginRight: '0.25rem' }} />
        Securities
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
